import i18n from 'i18next';
import en from './en.json';
import es from './es.json';

export const NS = 'password-policy';

// Guarded like the other self-registering features: under jest the i18next
// singleton is not initialised and has no addResourceBundle yet. In the app,
// i18n is initialised before any feature loads, so this always runs.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
}
